"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _customButtonIcon = _interopRequireDefault(require("./customButtonIcon.js"));

var _index = _interopRequireDefault(require("../../../utils/index.js"));

var _events = _interopRequireDefault(require("../../../utils/constants/events"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CustomButton =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CustomButton, _React$Component);

  function CustomButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CustomButton.prototype;

  _proto.render = function render() {
    var _this = this;

    var styleParams = this.props.styleParams;
    var defaultText = _index["default"].isStoreGallery() ? 'Buy Now' : 'Click here';
    var buttonText = styleParams.customButtonText || defaultText;
    return _react["default"].createElement("div", {
      className: "custom-button-wrapper",
      style: {
        justifyContent: styleParams.galleryHorizontalAlign,
        zIndex: 17
      }
    }, this.props.small ? _react["default"].createElement(_customButtonIcon["default"], null) : _react["default"].createElement("button", {
      "data-hook": "custom-button-button",
      onClick: function onClick() {
        return _this.props.actions.eventsListener(_events["default"].ON_BUY_NOW_CLICKED, _this.props);
      },
      tabIndex: -1
    }, buttonText, _react["default"].createElement("div", {
      className: "overlay"
    })));
  };

  return CustomButton;
}(_react["default"].Component);

exports["default"] = CustomButton;